import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom"
import { FaCheckCircle, FaPalette } from "react-icons/fa"
import RegistrationPage from "./RigistrationPage"
import RegistrationComplete from "./RegistrationComplete"
import "../../../assets/css/custom.css"
import axios from "axios"
import { localserver } from "../../../api/common"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
import { uploadFilesAWS } from "../../../api/Webservices"
import { useUser } from "../../AdminUsers/UserContext"
import { FaHome, FaChevronRight } from "react-icons/fa"

const EventRegistration = () => {
  const { checkPermission } = useUser()
  // State for EventRegistration
  const [activePage, setActivePage] = useState("success")

  // State for RegistrationComplete
  const [showRedirectInput, setShowRedirectInput] = useState(false)
  const [redirectUrl, setRedirectUrl] = useState("")
  const [isRedirectUrlValid, setIsRedirectUrlValid] = useState(true)
  const [displayRegistrationId, setDisplayRegistrationId] = useState(false)
  const { adminName, adminProfile, eventUrl, validation, getValidation } = useUser()
  // State for RegistrationPage
  const [isEventLogEnabled, setIsEventLogEnabled] = useState(false)
  const [gradient, setGradient] = useState("")
  const [backgroundOption, setBackgroundOption] = useState("abstract")
  const [selectedColor, setSelectedColor] = useState("#ffffff")
  const [primaryColor, setPrimaryColor] = useState("#007bff")
  const [selectedBackgroundImage, setSelectedBackgroundImage] = useState(null)
  const [selectedBackgroundImages, setSelectedBackgroundImages] = useState([])
  const [isPrimaryColorPickerOpen, setIsPrimaryColorPickerOpen] = useState(false)
  const [fileError, setFileError] = useState("")
  const [bannerImageError, setBannerImageError] = useState("")
  const [startColor, setStartColor] = useState("#3d6cbd")
  const [endColor, setEndColor] = useState("#503c3c")

  const [formState, setFormState] = useState({
    eventTitle: false,
    eventTitleValue: "",
    eventLogo: false,
    eventDateTimeLocation: false,
    registrationTitle: {
      show: false,
      value: "",
    },
    eventBanner: {
      show: false,
      value: "",
    },
    customTheme: false,
    backgroundOption: "abstract",
    customThemeAbstract: "",
    customThemeGradient: "",
    customThemeColor: "#ffffff",
    primaryColor: "#007bff",
    selectedBackgroundImage: null,
    displayEventPolicies: false,
    display_registration_id: false,
    registration_redirect: false,
    status: "active",
  })

  // State for API data
  const [eventData, setEventData] = useState(null)
  const [eventPageData, setEventPageData] = useState(null)

  // Ref for debouncing auto-save and storing previous payload
  const autoSaveTimeoutRef = useRef(null)
  const previousPayloadRef = useRef(null)

  // JSX Methods for rendering different sections
  const renderHeader = () => (
    <div style={{ position: "relative", overflow: "hidden" }}>
      <div style={{ marginBottom: "22px" }}>
        <div className="brood_comes_div">
          <div className="row align-items-center">
            <div className="col-md-6 brood_comes_heading">
              <h2>
                <div className="brood_comes_part">
                  <FaHome />
                </div>
                Event Page
              </h2>
              {/* <nav aria-label="breadcrumb">
                <ol
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    fontSize: "14px",
                  }}
                >
                  <li>
                    <Link
                      to="/events/admin/"
                      style={{
                        color: "#6b7280",
                        textDecoration: "none",
                        transition: "color 0.2s ease",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "#184778")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "#6b7280")}
                    >
                      AMASI
                    </Link>
                  </li>
                  <li style={{ color: "#d1d5db" }}>
                    <FaChevronRight size={10} />
                  </li>
                  <li style={{ color: "#184778", fontWeight: "500" }}>Event Page</li>
                </ol>
              </nav> */}

            </div>
          </div>
        </div>
      </div>
    </div>
  )

  const renderNavigationTabs = () => (
    <div style={{ position: "relative" }}>
      <div className="register_buton_events" >
        <button
          className={`page-button ${activePage === "success" ? "active" : ""}`}
          onClick={() => setActivePage("success")}>
          <div className={`icon-wrapper ${activePage === "success" ? "active" : ""}`}>
            <FaCheckCircle size={18} />
          </div>
          <div className="text-wrapper">
            <span className="title">Success Page</span>
            <span className="subtitle">Post-registration settings</span>
          </div>
        </button>

        <button
          className={`page-button ${activePage === "registration" ? "active" : ""}`}
          onClick={() => setActivePage("registration")}>
          <div className={`icon-wrapper ${activePage === "registration" ? "active" : ""}`}>
            <FaPalette size={18} />
          </div>
          <div className="text-wrapper">
            <span className="title">Registration Page</span>
            <span className="subtitle">Design & customization</span>
          </div>
        </button>

      </div>
    </div>
  )

  const renderMainContent = () => (
    <div style={{ margin: "0 auto" }}>
      <div className="innertabcontet_register">
        {activePage === "registration" && (
          <div style={{ padding: "15px 24px" }}>
            <div className="regis_tab_heading_content">
              <h2>
                Registration Page Design
              </h2>
              <p>
                Customize the appearance and layout of your event registration page
              </p>
            </div>
            <RegistrationPage
              eventData={eventData}
              eventPageData={eventPageData}
              isEventLogEnabled={isEventLogEnabled}
              gradient={gradient}
              backgroundOption={backgroundOption}
              selectedColor={selectedColor}
              primaryColor={primaryColor}
              selectedBackgroundImage={selectedBackgroundImage}
              selectedBackgroundImages={selectedBackgroundImages}
              isPrimaryColorPickerOpen={isPrimaryColorPickerOpen}
              fileError={fileError}
              startColor={startColor}
              endColor={endColor}
              formState={formState}
              handleEventLogToggle={handleEventLogToggle}
              handleBackgroundOptionChange={handleBackgroundOptionChange}
              handleColorChange={handleColorChange}
              handlePrimaryColorChange={handlePrimaryColorChange}
              handleFormChange={handleFormChange}
              handleFileUpload={handleFileUpload}
              handleImageClick={handleImageClick}
              handleImageUpload={handleImageUpload}
              handleFileChange={handleFileChange}
              handleStartColorChange={handleStartColorChange}
              handleEndColorChange={handleEndColorChange}
              setIsPrimaryColorPickerOpen={setIsPrimaryColorPickerOpen}
              setFileError={setFileError}
              setBannerImageError={setBannerImageError}
              bannerImageError={bannerImageError}
            />
          </div>
     )}

        {activePage === "success" && (
          <div style={{ padding: "15px 24px" }}>
            <div className="regis_tab_heading_content">
              <h2>
                Registration Success Settings
              </h2>
              <p>
                Configure what happens after users complete their registration
              </p>
            </div>
            <RegistrationComplete
              showRedirectInput={showRedirectInput}
              redirectUrl={redirectUrl}
              isRedirectUrlValid={isRedirectUrlValid}
              handleRedirectCheckboxChange={handleRedirectCheckboxChange}
              handleRedirectUrlChange={handleRedirectUrlChange}
              displayRegistrationId={displayRegistrationId}
              handleDisplayRegistrationIdChange={handleDisplayRegistrationIdChange}
            />
          </div>
        )}
      </div>
    </div>




  )

  // Handlers for RegistrationComplete
  const handleRedirectCheckboxChange = (e) => {
    const checked = e.target.checked
    setShowRedirectInput(checked)
    setFormState((prevState) => ({
      ...prevState,
      registration_redirect: checked,
    }))
    if (!checked) {
      setRedirectUrl("")
      setIsRedirectUrlValid(true)
    }
  }

  const handleRedirectUrlChange = (e) => {
    const value = e.target.value
    setRedirectUrl(value)
    setIsRedirectUrlValid(
      value.length === 0 || /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(value),
    )
  }

  const handleDisplayRegistrationIdChange = (e) => {
    const checked = e.target.checked
    setDisplayRegistrationId(checked)
    setFormState((prevState) => ({
      ...prevState,
      display_registration_id: checked,
    }))
  }

  // Handlers for RegistrationPage
  const handleEventLogToggle = () => {
    setIsEventLogEnabled(!isEventLogEnabled)
  }

  const handleBackgroundOptionChange = (option) => {
    setBackgroundOption(option)
    setSelectedBackgroundImage(null)
    setFormState((prevState) => ({ ...prevState, backgroundOption: option }))
  }

  const handleColorChange = (color) => {
    setSelectedColor(color)
    setFormState((prevState) => ({ ...prevState, customThemeColor: color }))
  }

  const handlePrimaryColorChange = (color) => {
    setPrimaryColor(color)
    setFormState((prevState) => ({ ...prevState, primaryColor: color }))
  }

  const handleFormChange = (field, value) => {
    setFormState((prevState) => ({
      ...prevState,
      [field]: value,
    }))
  }

  const handleStatusChange = (e) => {
    setFormState((prevState) => ({
      ...prevState,
      status: e.target.value,
    }))
  }

  const handleFileUpload = async (file) => {
    // Validate image
    const validationError = await validateImage(file)
    if (validationError) {
      setBannerImageError(validationError)
      return
    }

    // Upload to AWS
    try {
      const res = await uploadFilesAWS({ upload_files: file })
      if (res.data && res.data.success === true) {
        const uploadedUrl = res.data.uploadedUrls.upload_files[0]
        console.log("Uploaded file:", uploadedUrl)
        setSelectedBackgroundImage(file)
        setFormState((prevState) => ({
          ...prevState,
          eventBanner: {
            ...prevState.eventBanner,
            value: uploadedUrl ? uploadedUrl : "",
          },
        }))
        showToast("Image uploaded successfully", "success")
      } else {
        showToast(res.message || "Failed to upload image", "error")
      }
    } catch (error) {
      console.error(`Error uploading banner image:`, error)
      showToast(`Failed to upload banner image. Please try again.`, "error")
    }
    console.log("Uploaded file:", file)
  }

  const handleImageClick = (image) => {
    setSelectedBackgroundImages((prevSelectedImages) => {
      const newImages = prevSelectedImages.includes(image)
        ? prevSelectedImages.filter((img) => img !== image)
        : [...prevSelectedImages, image]
      setFormState((prevState) => ({
        ...prevState,
        customThemeAbstract: newImages.length > 0 ? newImages[0] : "",
      }))
      return newImages
    })
  }

  const handleImageUpload = () => {
    document.getElementById("imageUploadInput").click()
  }

  const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png"]
  const MAX_IMAGE_SIZE = 5 * 1024 * 1024 // 5MB
  const RECOMMENDED_WIDTH = 800
  const RECOMMENDED_HEIGHT = 270

  const validateImage = (file) => {
    if (file) {
      // Check image dimensions
      return new Promise((resolve) => {
        const img = new Image()
        const objectUrl = URL.createObjectURL(file)
        img.onload = () => {
          console.log(`Image dimensions: ${img.width} × ${img.height}`) // Debugging
          if (img.width !== RECOMMENDED_WIDTH || img.height !== RECOMMENDED_HEIGHT) {
            URL.revokeObjectURL(objectUrl)
            resolve(
              `Banner image dimensions should be ${RECOMMENDED_WIDTH} × ${RECOMMENDED_HEIGHT} pixels for best results.`,
            )
          } else {
            URL.revokeObjectURL(objectUrl)
            resolve(null)
          }
        }
        img.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          resolve(`Failed to load banner image. Please try again.`)
        }
        img.src = objectUrl
      })
    }
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0]

    try {
      const res = await uploadFilesAWS({ upload_files: file })
      if (res.data && res.data.success === true) {
        const uploadedUrl = res.data.uploadedUrls.upload_files[0]
        console.log("Uploaded file:", uploadedUrl)
        setSelectedBackgroundImage(file)
        setFormState((prevState) => ({
          ...prevState,
          selectedBackgroundImage: uploadedUrl,
        }))
        showToast("Image uploaded successfully", "success")
      } else {
        showToast(res.message || "Failed to upload image", "error")
      }
    } catch (error) {
      console.error(`Error uploading banner image:`, error)
      showToast(`Failed to upload banner image. Please try again.`, "error")
    }
  }

  const handleStartColorChange = (color) => {
    setStartColor(color)
    const newGradient = `linear-gradient(90deg, ${color}, ${endColor})`
    setGradient(newGradient)
    setFormState((prevState) => ({
      ...prevState,
      customThemeGradient: newGradient,
    }))
  }

  const handleEndColorChange = (color) => {
    setEndColor(color)
    const newGradient = `linear-gradient(90deg, ${startColor}, ${color})`
    setGradient(newGradient)
    setFormState((prevState) => ({
      ...prevState,
      customThemeGradient: newGradient,
    }))
  }

  // API calls
  const getEventById = async (event_id) => {
    try {
      const response = await axios.post(
        `${localserver}/get_event_details_by_event_id`,
        { event_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        const event = response.data.event
        console.log("Event Data:", event)
        getValidation();
        setEventData(event)
      } else {
        console.error("Error: Failed to fetch event data")
      }
    } catch (error) {
      console.error("Error fetching event data:", error)
    }
  }

  const getEventPageById = async (event_id) => {
    try {
      const response = await axios.post(
        `${localserver}/get_event_page_by_event_id`,
        { event_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        const eventPage = response.data.data
        console.log("Event Page:", eventPage)
        setEventPageData(eventPage)
      } else {
        console.error("Error: Failed to fetch event page data")
      }
    } catch (error) {
      console.error("Error fetching event page data:", error)
    }
  }

  const createUpdateEventPage = async (payload) => {
    const eventId = localStorage.getItem("eventId")
    if (!eventId) {
      console.error("error", "Event ID is missing")
      return
    }
    console.log("payload", payload)
    try {
      const response = await axios.post(`${localserver}/create_update_event_page`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
      if (response.data.success) {
        previousPayloadRef.current = payload // Update previous payload
        getEventPageById(eventId) // Refresh eventPageData
        showToast("Event page updated successfully", "success")
         getValidation();
      } else {
        console.error("Error: Failed to update event page")
        showToast("Failed to update event page","error")
      }
    } catch (error) {
      console.error("Error updating event page:", error)
    }
  }

  // Generate payload from formState and eventData
  const generatePayload = () => {
    const eventId = localStorage.getItem("eventId")
    return {
      event_id: Number.parseInt(eventId),
      event_banner_image: {
        show: formState.eventBanner.show ? "yes" : "no",
        value: formState.eventBanner.value || "",
      },
      event_title: {
        show: formState.eventTitle ? "yes" : "no",
        value: eventData?.event_name || formState.eventTitleValue || "",
      },
      event_organizer_logo: {
        show: formState.eventLogo ? "yes" : "no",
        value: eventData?.event_logo || "",
      },
      organizer_name: {
        show: "no",
        value: "",
      },
      event_date: {
        show: formState.eventDateTimeLocation ? "yes" : "no",
        value: eventData?.event_date || "",
      },
      location: {
        show: formState.eventDateTimeLocation ? "yes" : "no",
        value: eventData?.venue_city || "",
      },
      registration_fee: {
        show: "no",
        value: "",
      },
      registration_title: {
        show: formState.registrationTitle.show ? "yes" : "no",
        value: formState.registrationTitle.value || "",
      },
      custom_theme: {
        show: formState.customTheme ? "yes" : "no",
        type: formState.backgroundOption,
        abstract: formState.customThemeAbstract || "",
        gradient: formState.customThemeGradient || "",
        color: formState.customThemeColor || "#ffffff",
        primary_color: formState.primaryColor || "#007bff",
        image_url: formState.selectedBackgroundImage || "",
      },
      display_event_policies: {
        show: formState.displayEventPolicies ? "yes" : "no",
      },
      display_sponsors: {
        show: "no",
        image_url: "",
      },
      display_registration_id: {
        show: formState.display_registration_id ? "yes" : "no",
        value: "",
      },
      registration_redirect: {
        show: formState.registration_redirect ? "yes" : "no",
        value: formState.registration_redirect ? redirectUrl : "",
      },
      status: formState.status,
    }
  }

  // Parse gradient string to extract colors
  const parseGradientColors = (gradient) => {
    if (!gradient || typeof gradient !== "string") return { start: "#3d6cbd", end: "#503c3c" }
    const match = gradient.match(/linear-gradient$$90deg,\s*(#[0-9a-fA-F]{6})\s*,\s*(#[0-9a-fA-F]{6})\s*$$$/)
    return match ? { start: match[1], end: match[2] } : { start: "#3d6cbd", end: "#503c3c" }
  }

  // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false)
  const fetchPermission = async () => {
    setCheckUserLoading(true)
    try {
      const hasPermission = await checkPermission("Event Page", "view")
      if (!hasPermission) return
    } catch (error) {
      console.error("Error Check Permission:", error)
    } finally {
      setCheckUserLoading(false)
    }
  }
  useEffect(() => {
    fetchPermission()
  }, [])

  // Initialize formState with eventPageData
  useEffect(() => {
    const eventId = localStorage.getItem("eventId")
    if (eventId) {
      getEventById(eventId)
      getEventPageById(eventId)
    }
  }, [])

  useEffect(() => {
    if (eventPageData) {
      try {
        const parsedEventTitle = JSON.parse(eventPageData.event_title || '{"show":"no","value":""}')
        const parsedEventLogo = JSON.parse(eventPageData.event_organizer_logo || '{"show":"no","value":""}')
        const parsedEventDate = JSON.parse(eventPageData.event_date || '{"show":"no","value":""}')
        const parsedEventBanner = JSON.parse(eventPageData.event_banner_image || '{"show":"no","value":""}')
        const parsedCustomTheme = JSON.parse(
          eventPageData.custom_theme ||
          '{"show":"no","type":"abstract","abstract":"","gradient":"","color":"#ffffff","primary_color":"#007bff","image_url":""}',
        )
        const parsedDisplayEventPolicies = JSON.parse(eventPageData.display_event_policies || '{"show":"no"}')
        const parsedRegistrationTitle = JSON.parse(eventPageData.registration_title || '{"show":"no","value":""}')
        const parsedDisplayRegistrationId = JSON.parse(eventPageData.display_registration_id || '{"show":"no"}')
        const parsedRegistrationRedirect = JSON.parse(eventPageData.registration_redirect || '{"show":"no","value":""}')

        // Parse gradient colors
        const { start, end } = parseGradientColors(parsedCustomTheme.gradient)

        setFormState((prevState) => ({
          ...prevState,
          eventTitle: parsedEventTitle.show === "yes",
          eventTitleValue: parsedEventTitle.value || "",
          eventLogo: parsedEventLogo.show === "yes",
          eventDateTimeLocation: parsedEventDate.show === "yes",
          registrationTitle: {
            show: parsedRegistrationTitle.show === "yes",
            value: parsedRegistrationTitle.value || "",
          },
          eventBanner: {
            show: parsedEventBanner.show === "yes",
            value: parsedEventBanner.value || "",
          },
          customTheme: parsedCustomTheme.show === "yes",
          backgroundOption: parsedCustomTheme.type || "abstract",
          customThemeAbstract: parsedCustomTheme.abstract || "",
          customThemeGradient: parsedCustomTheme.gradient || "",
          customThemeColor: parsedCustomTheme.color || "#ffffff",
          primaryColor: parsedCustomTheme.primary_color || "#007bff",
          selectedBackgroundImage: parsedCustomTheme.image_url || null,
          displayEventPolicies: parsedDisplayEventPolicies.show === "yes",
          display_registration_id: parsedDisplayRegistrationId.show === "yes",
          registration_redirect: parsedRegistrationRedirect.show === "yes",
          status: eventPageData.status || "active",
        }))

        setBackgroundOption(parsedCustomTheme.type || "abstract")
        setSelectedColor(parsedCustomTheme.color || "#ffffff")
        setPrimaryColor(parsedCustomTheme.primary_color || "#007bff")
        setGradient(parsedCustomTheme.gradient || "")
        setStartColor(start)
        setEndColor(end)
        setSelectedBackgroundImage(parsedCustomTheme.image_url || null)
        setSelectedBackgroundImages(parsedCustomTheme.abstract ? [parsedCustomTheme.abstract] : [])
        setDisplayRegistrationId(parsedDisplayRegistrationId.show === "yes")
        setShowRedirectInput(parsedRegistrationRedirect.show === "yes")
        setRedirectUrl(parsedRegistrationRedirect.value || "")

        // Initialize previousPayloadRef with the initial payload
        const initialPayload = generatePayload()
        previousPayloadRef.current = initialPayload
      } catch (error) {
        console.error("Error parsing eventPageData:", error)
      }
    }
  }, [eventPageData])

  // Debounced auto-save for payload changes
  useEffect(() => {
    if (autoSaveTimeoutRef.current) {
      clearTimeout(autoSaveTimeoutRef.current)
    }
    autoSaveTimeoutRef.current = setTimeout(() => {
      const currentPayload = generatePayload()
      const previousPayload = previousPayloadRef.current
      // Compare payloads using JSON.stringify for deep comparison
      if (JSON.stringify(currentPayload) !== JSON.stringify(previousPayload)) {
        createUpdateEventPage(currentPayload)
      }
    }, 2000)
    return () => {
      if (autoSaveTimeoutRef.current) {
        clearTimeout(autoSaveTimeoutRef.current)
      }
    }
  }, [
    formState.eventBanner,
    formState.eventTitle,
    formState.eventTitleValue,
    formState.eventLogo,
    formState.eventDateTimeLocation,
    formState.registrationTitle,
    formState.customTheme,
    formState.backgroundOption,
    formState.customThemeAbstract,
    formState.customThemeGradient,
    formState.customThemeColor,
    formState.primaryColor,
    formState.selectedBackgroundImage,
    formState.displayEventPolicies,
    formState.display_registration_id,
    formState.registration_redirect,
    formState.status,
    redirectUrl,
    eventData,
  ])

  return (
    <>
      {checkUserLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div style={{ minHeight: "100vh", backgroundColor: "#f8fafc", padding: "24px 15px" }}>
          <ToastMessage />
          {renderHeader()}
          {renderNavigationTabs()}
          {renderMainContent()}
        </div>
      )}
    </>
  )
}

export default EventRegistration
